export default "/static/build/our-mission.webp";